// extracted by mini-css-extract-plugin
export var animated = "CubesPyramid-module--animated--QZ8PS";
export var cube = "CubesPyramid-module--cube--+Azqh";
export var rotation = "CubesPyramid-module--rotation--7CUyc";
export var translateContainer = "CubesPyramid-module--translateContainer--NkTTZ";
export var wrapper = "CubesPyramid-module--wrapper--D0Wx6";
export var wrapper__container = "CubesPyramid-module--wrapper__container--HHS4F";